import { render } from "./Yachts.vue?vue&type=template&id=b03f535c&scoped=true"
import script from "./Yachts.vue?vue&type=script&lang=ts"
export * from "./Yachts.vue?vue&type=script&lang=ts"

import "./Yachts.vue?vue&type=style&index=0&id=b03f535c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b03f535c"

export default script